// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ac-analysis-form-upload-result{width:34rem;overflow-x:hidden}.ac-analysis-form-upload-result .ac-tabs{margin-bottom:2.5rem}.ac-analysis-form-upload-result .ac-tabs__item{min-height:3rem}\n", ""]);
// Exports
module.exports = exports;
